import { render, staticRenderFns } from "./FormCorrespondent.vue?vue&type=template&id=5f1384db"
import script from "./FormCorrespondent.vue?vue&type=script&lang=js"
export * from "./FormCorrespondent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports